import { Api, Auth } from '~/services'
import { getMainFeed } from '~/actions/feed'


export function getCamp( slug_or_id ) {
	return ( dispatch, getStore ) => {

		if( !slug_or_id ) return;

		var passedData = {};
		if( Auth.getToken() ) passedData.secure_token = Auth.getToken()

		return dispatch(
			dispatch => {

				dispatch({
					type: 'REQUEST_CAMP'
				})

				Api.get( '/wp/camp/' + slug_or_id, passedData, ( data, error ) => {
					if ( ! data || error ) {
						return;
					}
					dispatch({
						type: 'RECEIVE_CAMP',
						post: data
					})
				})

			}
		)
	}
}


export function getUserCamps( ) {

	return ( dispatch, getStore ) => {

		if( !Auth.getToken() ) return;

		return dispatch(
			dispatch => {

				dispatch({
					type: 'REQUEST_USER_CAMPS'
				})

				Api.get( '/wp/camps', {
					secure_token: Auth.getToken()
				}, ( data, error ) => {
					if ( error ) return;
					dispatch({
						type: 'RECEIVE_USER_CAMPS',
						camps: data
					})
				})

			}
		)
	}
}


export function getCampUsers( campID ) {
	return ( dispatch, getStore ) => {

		if( !Auth.getToken() || !campID ) return;

		return dispatch(
			dispatch => {

				Api.get( '/wp/camp/' + campID + '/users', {
					secure_token: Auth.getToken()
				}, ( data, error ) => {
					if ( error ) return;
					dispatch({
						type: 'RECEIVE_CAMP',
						post: data
					})
				})

			}
		)
	}
}


export function getRecommendedCamps( ) {

	return ( dispatch, getStore ) => {

		if( !Auth.getToken() ) return;

		return dispatch(
			dispatch => {

				dispatch({
					type: 'REQUEST_RECOMMENDED_CAMPS'
				})

				Api.get( '/wp/camps/recommended', {
					secure_token: Auth.getToken()
				}, ( data, error ) => {
					if ( error ) return;
					dispatch({
						type: 'RECEIVE_RECOMMENDED_CAMPS',
						camps: data
					})
				})

			}
		)
	}
}


export function addCamp( passedData ) {

	return ( dispatch, getStore ) => {

		if( !Auth.getToken() || !passedData ) return;

		passedData.secure_token = Auth.getToken();

		return dispatch(
			dispatch => {

				dispatch({
					type: 'REQUEST_NEW_CAMP'
				})
				dispatch({
					type: 'REQUEST_CREDITS'
				})

				Api.uploadFormData( 'post', '/wp/camp', passedData, ( data, error ) => {
					if ( ! data || error ) {
						dispatch({
							type: 'RECEIVE_CREDITS'
						})
						dispatch({
							type: 'RECEIVE_NEW_CAMP'
						})
						return;
					}
					dispatch({
						type: 'RECEIVE_CREDITS',
						credits: data.credits
					})
					dispatch({
						type: 'RECEIVE_VISIBLE_NOTIFICATION',
						notification: data.notification
					})
					dispatch({
						type: 'RECEIVE_NEW_CAMP',
						post: data.camp
					})
				})

			}
		)
	}
}


export function joinCamp( campID, getFeed ) {
	return ( dispatch, getStore ) => {

		if( !Auth.getToken() ) return;

		return dispatch(
			dispatch => {

				dispatch({
					type: 'REQUEST_USER_CAMPS'
				})
				dispatch({
					type: 'REQUEST_CAMP'
				})

				Api.post( '/wp/camp/' + campID + '/user', {
					secure_token: Auth.getToken()
				}, ( data, error ) => {
					if ( ! data || error ) {
						return;
					}
					dispatch({
						type: 'RECEIVE_VISIBLE_NOTIFICATION',
						notification: data.notification
					})
					dispatch({
						type: 'RECEIVE_CAMP',
						post: data.camp
					})
					dispatch({
						type: 'RECEIVE_USER_CAMPS',
						camps: data.user_camps
					})

					if( getFeed ) dispatch( getMainFeed() )

				})

			}
		)
	}
}


export function leaveCamp( campID ) {
	return ( dispatch, getStore ) => {

		if( !Auth.getToken() ) return;

		return dispatch(
			dispatch => {

				dispatch({
					type: 'REQUEST_USER_CAMPS'
				})
				dispatch({
					type: 'REQUEST_CAMP'
				})

				Api.delete( '/wp/camp/' + campID + '/user', {
					secure_token: Auth.getToken()
				}, ( data, error ) => {
					if ( ! data || error ) {
						return;
					}
					dispatch({
						type: 'RECEIVE_VISIBLE_NOTIFICATION',
						notification: data.notification
					})
					dispatch({
						type: 'RECEIVE_CAMP',
						post: data.camp
					})
					dispatch({
						type: 'RECEIVE_USER_CAMPS',
						camps: data.user_camps
					})
				})

			}
		)
	}
}


export function approveUser( campID, userID ) {
	return ( dispatch, getStore ) => {

		if( !Auth.getToken() || !campID || !userID ) return;

		return dispatch(
			dispatch => {

				dispatch({
					type: 'REQUEST_CAMP'
				})

				Api.post( '/wp/camp/' + campID + '/user/' + userID + '/approve', {
					secure_token: Auth.getToken()
				}, ( data, error ) => {
					if ( ! data || error ) {
						return;
					}
					dispatch({
						type: 'RECEIVE_VISIBLE_NOTIFICATION',
						notification: data.notification
					})
					dispatch({
						type: 'RECEIVE_CAMP',
						post: data.camp
					})
				})

			}
		)
	}
}


export function rejectUser( campID, userID ) {
	return ( dispatch, getStore ) => {

		if( !Auth.getToken() || !campID || !userID ) return;

		return dispatch(
			dispatch => {

				dispatch({
					type: 'REQUEST_CAMP'
				})

				Api.post( '/wp/camp/' + campID + '/user/' + userID + '/reject', {
					secure_token: Auth.getToken()
				}, ( data, error ) => {
					if ( ! data || error ) {
						return;
					}
					dispatch({
						type: 'RECEIVE_VISIBLE_NOTIFICATION',
						notification: data.notification
					})
					dispatch({
						type: 'RECEIVE_CAMP',
						post: data.camp
					})
				})

			}
		)
	}
}


export function removeUser( campID, userID ) {
	return ( dispatch, getStore ) => {

		if( !Auth.getToken() || !campID || !userID ) return;

		return dispatch(
			dispatch => {

				dispatch({
					type: 'REQUEST_CAMP'
				})

				Api.post( '/wp/camp/' + campID + '/user/' + userID + '/remove', {
					secure_token: Auth.getToken()
				}, ( data, error ) => {
					if ( ! data || error ) {
						return;
					}
					dispatch({
						type: 'RECEIVE_VISIBLE_NOTIFICATION',
						notification: data.notification
					})
					dispatch({
						type: 'RECEIVE_CAMP',
						post: data.camp
					})
				})

			}
		)
	}
}


export function requestCampNotification() {
	return ( dispatch, getStore ) => {

		if( !Auth.getToken() ) return;

		return dispatch(
			dispatch => {

				Api.post( '/wp/camp/notify-when-available', {
					secure_token: Auth.getToken()
				}, ( data, error ) => {
					if ( ! data || error ) {
						return;
					}
					dispatch({
						type: 'RECEIVE_VISIBLE_NOTIFICATION',
						notification: data
					})
				})

			}
		)
	}
}



// WEBPACK FOOTER //
// ./src/js/actions/camps.js